import React, { useState, useEffect } from 'react';
import { supabase, supabaseAdmin } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';
import {
  FaUserPlus,
  FaSignOutAlt,
  FaEnvelope,
  FaCar,
  FaSearch,
  FaUser,
  FaCog,
  FaUsers
} from 'react-icons/fa';
import '../../styles/styles.css';
import '../../styles/toggle.css';
import ServiceForm from '../employee/serviceForm';
import ServiceSearch from '../employee/serviceSearch';
import UserSearch from './userSearch';

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('invitar');
  const [isEmployeeView, setIsEmployeeView] = useState(false);
  const [employeeActiveTab, setEmployeeActiveTab] = useState('service');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [invitations, setInvitations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
    loadInvitations();
  }, []);

  const checkAuth = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      navigate('/login');
      return;
    }

    const adminEmails = ['agussourrouille9@gmail.com'];
    if (!adminEmails.includes(user.email)) {
      navigate('/empleado');
    }
  };

  const loadInvitations = async () => {
    try {
      const savedInvitations = localStorage.getItem('invitations');
      if (savedInvitations) {
        setInvitations(JSON.parse(savedInvitations));
      }
    } catch (error) {
      console.error('Error cargando invitaciones:', error);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  const sendInvitation = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    try {
      const { error } = await supabaseAdmin.auth.admin.inviteUserByEmail(email);
      if (error) {
        setError(error.message);
      } else {
        setMessage(`Invitación enviada exitosamente a ${email}.`);
        setEmail('');
        const newInvitation = {
          id: Date.now(),
          email,
          status: 'sent',
          sent_at: new Date().toISOString()
        };
        const currentInvitations = JSON.parse(localStorage.getItem('invitations') || '[]');
        currentInvitations.unshift(newInvitation);
        localStorage.setItem('invitations', JSON.stringify(currentInvitations));
        loadInvitations();
      }
    } catch (error) {
      setError('Error al enviar invitación: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteInvitation = (id) => {
    const updatedInvitations = invitations.filter(inv => inv.id !== id);
    setInvitations(updatedInvitations);
    localStorage.setItem('invitations', JSON.stringify(updatedInvitations));
  };

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <div className="logo-section">
            <div className="logo-icon">
              {isEmployeeView ? <FaCog /> : <FaUserPlus />}
            </div>
            <h1>{isEmployeeView ? 'Panel de Empleado' : 'Panel de Administrador'}</h1>
          </div>
          <div className="header-actions">
            <button
              onClick={() => navigate('/perfil')}
              className="profile-button"
              title="Editar Perfil"
              style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '1rem' }}
            >
              <FaUser />
            </button>
            <div className="view-switch">
              <div
                className={`switch-option ${!isEmployeeView ? 'active' : ''}`}
                onClick={() => setIsEmployeeView(false)}
              >
                Admin
              </div>
              <div
                className={`switch-option ${isEmployeeView ? 'active' : ''}`}
                onClick={() => setIsEmployeeView(true)}
              >
                Empleado
              </div>
              <div className={`switch-slider ${isEmployeeView ? 'employee' : ''}`}></div>
            </div>
            <button onClick={handleLogout} className="logout-button">
              <FaSignOutAlt />
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      {isEmployeeView ? (
        <div className="tabs-container">
          <div className="tabs">
            <button
              className={`tab ${employeeActiveTab === 'service' ? 'active' : ''}`}
              onClick={() => setEmployeeActiveTab('service')}
            >
              <FaCar className="mr-2" /> Cargar Service
            </button>
            <button
              className={`tab ${employeeActiveTab === 'search' ? 'active' : ''}`}
              onClick={() => setEmployeeActiveTab('search')}
            >
              <FaSearch className="mr-2" /> Búsquedas
            </button>
          </div>
        </div>
      ) : (
        <div className="tabs-container">
          <div className="tabs">
            <button
              className={`tab ${activeTab === 'invitar' ? 'active' : ''}`}
              onClick={() => setActiveTab('invitar')}
            >
              <FaUserPlus className="mr-2" /> Invitar Empleados
            </button>
            <button
              className={`tab ${activeTab === 'usuarios' ? 'active' : ''}`}
              onClick={() => setActiveTab('usuarios')}
            >
              <FaUsers className="mr-2" /> Ver Usuarios
            </button>
          </div>
        </div>
      )}

      {/* Tab Content */}
      <div className="tab-content">
        {isEmployeeView ? (
          <div className="animate-fade-in">
            {employeeActiveTab === 'service' && <ServiceForm />}
            {employeeActiveTab === 'search' && <ServiceSearch />}
          </div>
        ) : (
          <div className="animate-fade-in">
            {/* Invitar empleados */}
            {activeTab === 'invitar' && (
              <div className="invite-container">
                <div className="invite-section">
                  <h2>Invitar Nuevo Empleado</h2>
                  <p>Envía una invitación por email para que se registren</p>
                  <form onSubmit={sendInvitation} className="invite-form">
                    {message && <div className="success-message">{message}</div>}
                    {error && <div className="error-message">{error}</div>}
                    <div className="form-field">
                      <label>Email del empleado</label>
                      <div className="input-wrapper">
                        <FaEnvelope className="input-icon" />
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          placeholder="empleado@ejemplo.com"
                          disabled={loading}
                        />
                      </div>
                    </div>
                    <button
                      type="submit"
                      disabled={loading}
                      className="submit-button"
                    >
                      {loading ? 'Enviando...' : 'Enviar Invitación'}
                    </button>
                  </form>
                </div>
                <div className="invitations-section">
                  <h3>Invitaciones Enviadas</h3>
                  <div className="invitations-list">
                    {invitations.length === 0 ? (
                      <p className="no-invitations">No hay invitaciones enviadas</p>
                    ) : (
                      invitations.map((invitation) => (
                        <div key={invitation.id} className="invitation-item">
                          <div className="invitation-info">
                            <p className="invitation-email">{invitation.email}</p>
                            <p className="invitation-date">
                              {new Date(invitation.sent_at).toLocaleDateString()}
                            </p>
                          </div>
                          <span className={`invitation-status ${invitation.status}`}>
                            {invitation.status === 'sent' ? 'Enviada' :
                              invitation.status === 'completed' ? 'Completada' : invitation.status}
                          </span>
                          <button
                            className="delete-invitation-btn"
                            onClick={() => deleteInvitation(invitation.id)}
                          >
                            ✕
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            )}
            {/* Usuarios */}
            {activeTab === 'usuarios' && <UserSearch />}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;